import type { GridFilterModel } from '@mui/x-data-grid-pro';
import type { DocumentState } from 'components/common/dataGrid/columnsFactory/types';
import { getProjectInfo } from 'store/project';
import type { FilteredDirectoryRequest } from 'shared/domain/documentation/documentationContract';
import { DEFAULT_FILTER_MODEL } from '../filters/model';

/**
 * Service worker request for a directory listing. Every caller builds it here,
 * so the same directory is requested with the same parameters - the service
 * worker caches by them, and date filters use the project timezone.
 */
export function buildFilteredDirectoryRequest({
  parentId,
  filterModel,
  documentState,
}: {
  parentId: string;
  filterModel: GridFilterModel | undefined;
  documentState: DocumentState;
}): FilteredDirectoryRequest {
  const { timezone, organizationId } = getProjectInfo();
  return {
    parentId,
    filterModel: filterModel ?? DEFAULT_FILTER_MODEL,
    documentState,
    timezone,
    organizationId: organizationId || null,
  };
}
